import { z } from 'zod';
/** Tipos de comprobante y de mensaje que llevan consecutivo propio por sucursal y terminal. */
export const SEQUENCE_KINDS = [
    { code: 'FE', name: 'Factura electrónica' },
    { code: 'TE', name: 'Tiquete electrónico' },
    { code: 'NC', name: 'Nota de crédito' },
    { code: 'ND', name: 'Nota de débito' },
    { code: 'FEC', name: 'Factura de compra' },
    { code: 'CCE', name: 'Aceptación de comprobante' },
    { code: 'CPCE', name: 'Aceptación parcial' },
    { code: 'RCE', name: 'Rechazo de comprobante' },
];
export const setSequenceInput = z.object({
    terminalId: z.uuid(),
    kind: z.enum(['FE', 'TE', 'NC', 'ND', 'FEC', 'CCE', 'CPCE', 'RCE']),
    /** Número del próximo comprobante a emitir. */
    nextValue: z.coerce.number().int().min(1).max(9_999_999_999),
});
//# sourceMappingURL=sequences.js.map